import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const Prerise = ({ os }) => (
  <React.Fragment>
    <div className="light1" />
    <div className="light2" />
    <div className="light3" />
    <div className="rocket" />
    <div className="meteor1" />
    { os === DEVICE.MOBILE
      && <div className="meteor2" />
    }
    <div className="ufo" />
    <div className="star1" />
    <div className="star2" />
    <div className="star3" />
    <div className="star4" />
    <div className="star5" />
    <div className="star6" />
    <div className="star7" />
    <div className="shadow1" />
    <div className="shadow2" />
    { os === DEVICE.PC
      && (
        <React.Fragment>
          <div className="light4" />
          <div className="shadow3" />
          <div className="planet4" />
        </React.Fragment>
      )
    }
    <div className="planet1" />
    <div className="planet2" />
    <div className="planet3" />
  </React.Fragment>
);

Prerise.propTypes = {
  os: PropTypes.string,
};
export default Prerise;
